// extracted by mini-css-extract-plugin
export default {"container":"NbwpvH","logoContainer":"gA7W3z","logo":"PtAn1y"};